import React from 'react';
import clsx from 'clsx';

const PublicShell = ({
  children,
  header,
  footer,
  className,
  mainClassName,
  ...props
}) => {
  return (
    <div
      className={clsx('min-h-screen', className)}
      style={{ backgroundColor: 'var(--background, #FFFFFF)' }}
      {...props}
    >
      <div className="flex min-h-screen flex-col">
        {header}
        <div className="flex-1 px-2 sm:px-4">
          <div
            className="mx-auto w-full max-w-[1200px]"
            style={{ backgroundColor: 'var(--surface, #F8FAFC)' }}
          >
            <main className={clsx('flex-1', mainClassName)}>{children}</main>
          </div>
        </div>
        {footer}
      </div>
    </div>
  );
};

export default PublicShell;
